 import Client from "./client";

export default class Transactions {
    constructor() {
        this.client = new Client()
    }

    async prices(currency) {
        return this.client.http().get(`/v1/prices/${currency}`)
    }

    async checkoutLink(data) {
        return this.client.http().post("/v1/checkout/link", data)
    }

    async startTrial(data) {
        return this.client.http().post("/v1/trial", data)
    }

    async getCurrencyRates() {
        return this.client.http().get("/v1/currency-rates")
    }
}